import React from 'react'
import classNames from 'classnames'

import { colors, fontSizes } from '../../../constants/salesStyles'
import AIIcon from '../AIIcon/AIIcon'
import SalesText from '../SalesText/SalesText'

import styles from './styles.module.scss'

interface IProps {
    onClick: () => void
    className?: string
    disabled?: boolean
}

const AIBadge: React.FC<IProps> = ({ onClick, className, disabled = false }) => {
    return (
        <button
            className={classNames(styles.badge, className, { [styles.disabled]: disabled })}
            onClick={onClick}
            disabled={disabled}
            title="Сгенерировать описание по ОЕМ"
        >
            <AIIcon className={styles.icon} />
            <SalesText 
                text="AI Сгенерировать описание" 
                color={colors.white}
                fontSize={fontSizes.xxs}
                marginLeftPixels={4}
            />
        </button>
    )
}

export default AIBadge 